import React from "react";
import { Alert } from "react-bootstrap";
import { useGlobalAlert } from "./AlertContext";

export default function GlobalAlert() {
  const { alert, hideAlert } = useGlobalAlert();

  if (!alert.show || !alert.message) return null;

  return (
    <Alert
      variant={alert.variant}
      dismissible
      onClose={() => {
        if (typeof alert.onClose === "function") alert.onClose();
        hideAlert();
      }}
      style={{
        position: "fixed",
        top: 130,
        left: "50%",
        transform: "translateX(-50%)",
        zIndex: 2000,
        minWidth: 320,
        boxShadow: "0 2px 16px rgba(0,0,0,0.18)"
      }}
    >
      {alert.message}
    </Alert>
  );
}
